<script>
import { mapActions, mapState } from "vuex";
import PrefectureList from "@/mixins/PrefectureList";

export default {
  name: "chooseEmissionModal",
  components: {},
  mixins: [PrefectureList],
  props: {
    enable: {
      type: Boolean,
      default: false,
    },
    withoutGeneralForm: {
      type: Boolean,
      default: () => false,
    },
    withoutInvisible: {
      type: Boolean,
      default: () => false,
    },
    onlyValidLocation: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      page: 1,
      totalVisible: 7,
      tableEmissionIsBillingHeaders: [
        { value: "code", text: "事業者コード\r\n加入者番号", width: "15%" },
        { value: "name", text: "取引先名", width: "45%" },
        { value: "billing_address_name", text: "請求先名", width: "40%" },
      ],
      tableEmissionHeaders: [
        { value: "code", text: "事業者コード\r\n加入者番号", width: "15%" },
        { value: "name", text: "取引先名", width: "45%" },
        { value: "address", text: "住所", width: "40%" },
      ],
      emissions: [],
      choseRow: null,
      choseEmission: null,
      searchForm: {
        free_word: null,
        code: null,
        subscriber_no: null,
        name: null,
        billing_address_name: null,
        prefecture_code: null,
        address: null,
      },
      pagination: {
        current_page: 1,
        total_count: 0,
      },
    };
  },
  computed: {
    ...mapState("DriverTenantConfiguration", {
      useBilling: "use_billing",
    }),
  },
  watch: {
    enable(value) {
      this.emissions = [];
      this.choseEmission = null;
      this.page = 1;
      Object.assign(this.$data.searchForm, this.$options.data().searchForm);
      Object.assign(this.$data.pagination, this.$options.data().pagination);
      if (this.choseRow) {
        this.choseRow.select(false);
        this.choseRow = null;
      }
      if (value) {
        this.searchEmissions();
      }
    },
  },
  created() {},
  methods: {
    ...mapActions("DriverMasterSearchEmissionMember", {
      fetchEmissionMembers: "index",
    }),
    /**
     * 排出事業者 反映ボタン クリックイベント
     * 呼び出し元で定義されたコールバックをキックし、選択された排出事業者情報を返します.
     */
    registerButtonClickEvent() {
      this.$emit("selected", this.choseEmission);
    },
    closeButtonClickEvent() {
      this.$emit("close");
    },
    /**
     * 排出事業者
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent() {
      this.emissions = [];
      this.page = 1;
      this.choseEmission = null;
      if (this.choseRow) {
        this.choseRow.select(false);
        this.choseRow = null;
      }
      this.searchEmissions();
    },
    pageChangeEvent() {
      this.searchEmissions();
    },
    /**
     * 排出事業者行選択イベント
     * @param item
     * @param row
     */
    rowClickEvent(item, row) {
      this.choseEmission = item;
      this.choseEmission.type = "Emission";
      this.choseRow = row;
      row.select(true);
    },
    /**
     * 事業者行 ダブルクリックイベント
     * @param $event { MouseEvent }
     * @param row { Object } 行
     */
    rowDoubleClickEvent($event, row) {
      this.$emit("selected", row.item);
    },
    searchEmissions() {
      let params = {
        ...this.searchForm,
        without_general_form: this.withoutGeneralForm,
        without_invisible: this.withoutInvisible,
        only_valid_location: this.onlyValidLocation,
        page: this.page,
      };
      this.fetchEmissionMembers({ params: params }).then((content) => {
        this.emissions = content.emissions;
        this.pagination = content.pagination;
      });
    },
  },
};
</script>
<template>
  <div>
    <v-dialog
      v-model="enable"
      persistent
      scrollable
      width="900"
      @keydown.esc="closeButtonClickEvent"
      @close="closeButtonClickEvent"
    >
      <v-card flat>
        <v-toolbar flat>
          <v-toolbar-title>排出事業者から選択</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <!-- 検索 -->
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="searchForm.free_word"
                  clearable
                  dense
                  hide-details="auto"
                  label="排出事業者名称・事業場名称・事業者コード・事業場コード（空白区切り可）"
                  outlined
                  persistent-placeholder
                  placeholder="例）DXE 丸の内 001"
                  ref="free_word"
                  rounded
                  @blur="searchButtonClickEvent"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="!useBilling">
              <!-- 加入者番号 -->
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="searchForm.subscriber_no"
                  dense
                  hide-details="auto"
                  label="加入者番号"
                  clearable
                  outlined
                  persistent-placeholder
                  placeholder="例）1234567"
                  rounded
                  @blur="searchButtonClickEvent"
                />
              </v-col>
              <!-- /加入者番号 -->
              <!-- 請求先名 -->
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="searchForm.billing_address_name"
                  dense
                  hide-details="auto"
                  label="請求先名"
                  clearable
                  outlined
                  persistent-placeholder
                  placeholder="部分一致で検索"
                  rounded
                  @blur="searchButtonClickEvent"
                />
              </v-col>
              <!-- /請求先名 -->
            </v-row>
            <v-row v-else>
              <!-- 加入者番号 -->
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="searchForm.subscriber_no"
                  dense
                  hide-details="auto"
                  label="加入者番号"
                  clearable
                  outlined
                  persistent-placeholder
                  placeholder="例）1234567"
                  rounded
                  @blur="searchButtonClickEvent"
                />
              </v-col>
              <!-- /加入者番号 -->

              <!-- 都道府県コードのみ -->
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="searchForm.prefecture_code"
                  :items="prefList"
                  clearable
                  dense
                  hide-details="auto"
                  label="都道府県"
                  outlined
                  persistent-placeholder
                  placeholder="例）東京都"
                  rounded
                  @change="searchButtonClickEvent"
                />
              </v-col>
              <!-- /都道府県コードのみ -->
              <!-- 町域・詳細住所 -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="searchForm.address"
                  dense
                  label="市区町村・町域・詳細住所"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）中央区日本橋兜町１－２－３○○ビル○階"
                  rounded
                  @blur="searchButtonClickEvent"
                />
              </v-col>
              <!-- /町域・詳細住所 -->
            </v-row>
            <v-row dense>
              <v-col class="text-right">
                <v-btn color="primary" @click="searchButtonClickEvent">
                  <v-icon>mdi-magnify</v-icon>&nbsp;検索
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <!-- /検索 -->

          <!-- 一覧 -->
          <v-data-table
            :headers="
              useBilling ? tableEmissionIsBillingHeaders : tableEmissionHeaders
            "
            :items="emissions"
            :items-per-page="-1"
            disable-sort
            single-select
            fixed-header
            hide-default-footer
            @click:row="rowClickEvent"
            @dblclick:row="rowDoubleClickEvent"
          >
            <template v-slot:[`item.code`]="{ item }">
              <div>{{ item.code }}&nbsp;</div>
              {{ item.subscriber_number }}
            </template>
            <!-- 取引先名 -->
            <template v-slot:[`item.name`]="{ item }">
              <div style="display: flex; align-items: center; gap: 4px;">
                <v-img
                  v-if="item.use_station"
                  max-height="18"
                  max-width="18"
                  :src="require(`@/assets/images/DXE_mark.svg`)"
                />
                <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  <span :title="item.name">{{ item.name }} </span>
                </div>
                <v-tooltip v-if="useBilling" top :open-on-hover="false">
                  <template #activator="{ on }">
                    <v-btn
                      icon
                      small
                      retain-focus-on-click
                      @click="on.click"
                      @blur="on.blur"
                    >
                      <v-icon small> mdi-map-marker-outline </v-icon>
                    </v-btn>
                  </template>
                  <div
                    :title="item.address"
                    class="ellipsis-text"
                    style="max-width: 250px; width: initial; font-size: 90%"
                  >
                    {{ item.address }}
                  </div>
                </v-tooltip>
              </div>
            </template>
            <!-- /取引先名 -->
            <!-- 請求先名 -->
            <template
              v-if="useBilling"
              v-slot:[`item.billing_address_name`]="{ item }"
            >
              <div
                v-if="item.billing_address"
                :title="item.billing_address.name"
                class="ellipsis-text"
                style="max-width: 250px; width: initial; font-size: 90%"
              >
                {{ item.billing_address.name }}
              </div>
            </template>
            <template v-if="!useBilling" v-slot:[`item.address`]="{ item }">
              <div
                :title="item.address"
                class="ellipsis-text"
                style="max-width: 250px; width: initial; font-size: 85%"
              >
                {{ item.address }}
              </div>
            </template>
            <!-- /請求先名 -->
          </v-data-table>
          <!-- /一覧 -->
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row dense>
            <v-col>
              <v-pagination
                v-model="page"
                :length="pagination.total_pages"
                :total-visible="totalVisible"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="pageChangeEvent"
              />
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeButtonClickEvent" @mousedown.prevent>
            閉じる
          </v-btn>
          <v-btn
            :disabled="!choseEmission"
            class="primary"
            @click="registerButtonClickEvent"
          >
            反映
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
